import {Component, Input} from "@angular/core";

@Component({
    selector: 'flag-icon',
    template: `<i class="margin-right-4 fi fi-{{country}}" [ngClass]="flagIconClass"></i>`,
    standalone: false
})
export class FlagIconComponent {
    country: string;
    @Input() set localeCountry(value: string) {
        this.country = value.toLowerCase() === 'uk' ? 'gb' : value.toLowerCase();
    }
    @Input() flagIconClass: string;
}
